import { main_url } from "../pages/basefile";
import { getValidToken } from "../auth/getToken";

async function getAuthHeaders() {
  const token = (await getValidToken()) || localStorage.getItem("authToken");
  if (!token) {
    throw new Error("Authentication required. Redirecting to login.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

async function handleResponse(response) {
  if (!response.ok) {
    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
      const data = await response.json();
      throw new Error(data?.detail || data?.message || `HTTP ${response.status}`);
    }
    const text = await response.text();
    throw new Error(text || `HTTP ${response.status}`);
  }
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    return response.json();
  }
  return response;
}

export async function fetchMyPatientQuestionnaireVisits() {
  const headers = await getAuthHeaders();
  const response = await fetch(`${main_url}/api/v1/me/patient-questionnaire-visits`, {
    method: "GET",
    headers,
    cache: "no-store",
  });
  return handleResponse(response);
}

export async function fetchPatientQuestionnaires({ executionId, scheduleId }) {
  const headers = await getAuthHeaders();
  const response = await fetch(
    `${main_url}/api/v1/executions/${executionId}/schedules/${scheduleId}/patient-questionnaires`,
    {
      method: "GET",
      headers,
    }
  );
  return handleResponse(response);
}

export async function submitPatientQuestionnaire({
  executionId,
  scheduleId,
  qid,
  answersJson,
}) {
  const headers = await getAuthHeaders();
  const response = await fetch(
    `${main_url}/api/v1/executions/${executionId}/schedules/${scheduleId}/patient-questionnaires/${qid}`,
    {
      method: "POST",
      headers,
      body: JSON.stringify(answersJson || {}),
    }
  );
  return handleResponse(response);
}

